"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetTimeValues = void 0;
var _Alert = _interopRequireDefault(require("./../Alert/Alert"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _array = require("./../../utils/type-checks/array");
var _date = require("./../../utils/type-checks/date");
var _string = require("./../../utils/type-checks/string");
var _useSiteConfigContext = require("./../../utils/hooks/useSiteConfigContext");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GetTimeValues = (maintenanceArray, id) => {
  const context = (0, _array.isArrayOfLength)(maintenanceArray) && (0, _string.isStringOfLength)(id) ? maintenanceArray.filter(item => item.id === id) : [],
    maintStart = (0, _array.isArrayOfLength)(context) && context[0]?.maintBegin ? new Date(parseInt(context[0].maintBegin, 10)) : null,
    maintEnd = (0, _array.isArrayOfLength)(context) && context[0]?.maintEnd ? new Date(parseInt(context[0].maintEnd, 10)) : null,
    dateFormat = {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    timeFormat = {
      hour: "numeric",
      hour12: true,
      minute: "numeric",
      timeZoneName: "short"
    };
  return {
    maintenanceStartDate: (0, _date.isDate)(maintStart) ? Intl.DateTimeFormat("default", dateFormat).format(maintStart) : "error parsing date",
    maintenanceEndDate: (0, _date.isDate)(maintEnd) ? Intl.DateTimeFormat("default", dateFormat).format(maintEnd) : "error parsing date",
    maintenanceStartTime: (0, _date.isDate)(maintStart) ? Intl.DateTimeFormat("default", timeFormat).format(maintStart) : "error parsing date",
    maintenanceEndTime: (0, _date.isDate)(maintEnd) ? Intl.DateTimeFormat("default", timeFormat).format(maintEnd) : "error parsing date"
  };
};

/**
 * Sample site alerts component to inject timed alerts into header
 *
 * @visibleName Site Alerts
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.GetTimeValues = GetTimeValues;
const SiteAlerts = props => {
  const {
      customTheme = {},
      testId
    } = props,
    {
      maintenance
    } = (0, _useSiteConfigContext.useSiteConfigContext)(),
    mfiplTimes = GetTimeValues(maintenance, "mfipl"),
    sm001Times = GetTimeValues(maintenance, "sm001");
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    customTheme: customTheme,
    id: "alert__mainframe",
    contextId: "mfipl"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "h1",
    id: "maintenance-notification-1"
  }, "Maintenance Notification"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p"
  }, "Several systems will be down for maintenance on ", mfiplTimes.maintenanceStartDate, " from ", mfiplTimes.maintenanceStartTime, " to ", mfiplTimes.maintenanceEndTime, "."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p"
  }, "During this time, you may not be able to access your account online or through the mobile application, make payments, or perform other online activities. Automated telephone support may also be limited.  Thank you for your patience.")), /*#__PURE__*/_react.default.createElement(_Alert.default, {
    customTheme: customTheme,
    id: "alert__scheduled",
    contextId: "sm001"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "h1",
    id: "maintenance-notification-2"
  }, "Maintenance Notification"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Our system will be down for maintenance on ", sm001Times.maintenanceStartDate, " from ", sm001Times.maintenanceStartTime, " through ", sm001Times.maintenanceEndDate, " at ", sm001Times.maintenanceEndTime, "."), " During this time, you may not be able to access our interactive voice response system or your online account."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "p"
  }, "We apologize for any inconvenience this may cause and thank you for your patience.")));
};

// Define propTypes;
SiteAlerts.propTypes = {
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = SiteAlerts;